import { defineMessage } from '../../../../services/localization';

export const messages = {
    defaultDropdownName: defineMessage('section'),
};
